module.exports = dormakaba.vendorTerrific['vendor/tslib'];